/* eslint-disable no-useless-concat */

const baseName = '/survey/group-survey'
const tokenBaseName = '/token'

const diversity_survey_route = {
    diversityHome: baseName + '/survey' + '/:id',
    tokenSurvey: baseName + '/survey' + tokenBaseName + '/:token',

}

export default diversity_survey_route